export enum RecipientType {
  Signer = 'Signer',
  Reviewer = 'Reviewer',
}
